import { Component, ContentChildren, Directive, ElementRef, EventEmitter, Input, Output, ViewChild, ViewChildren } from '@angular/core';
import { ColumnOrderDirective } from './column-order.directive';

@Directive({
    selector: '[re-column-order-data]',
    standalone: false
})
export class ColumnOrderDataDirective {

  constructor(private el: ElementRef) {
  }


  directives: ColumnOrderDirective[] = [];

  registreOrderDirective(directive: ColumnOrderDirective) {
    this.directives.push(directive);
  }

  private _data: any[];
  public get data(): any[] {
    return this._data;
  }
  @Input("re-column-order-data")
  public set data(value: any[]) {

    if (this._data != value) {
      this._data = value;

      let table = <HTMLTableElement>this.el.nativeElement
      let ths = table.querySelectorAll("th.sorting");
      ths.forEach((th: HTMLTableHeaderCellElement) => {
        if (th.classList.contains("sorting_asc") || th.classList.contains("sorting_desc")) {
          let key = th.attributes["re-column-order-property"].value;
          let directive = this.directives.firstOrDefault(x => x.column == key);
          directive.order();
          return;
        }

      });
    }

  
  }


  @Output("re-column-order-dataChange")
  public dataChange = new EventEmitter<any[]>();

}
